import { useCallback, useLayoutEffect, useState } from 'react';

const DEFAULT_FLYOUT_HEIGHT = 180;

export default function useSidebarFlyoutPosition(open, anchorRef, panelRef, flyoutWidth = 320) {
  const [style, setStyle] = useState({ top: 0, left: 0, maxHeight: DEFAULT_FLYOUT_HEIGHT });

  const updatePosition = useCallback(() => {
    const anchor = anchorRef.current;
    const panel = panelRef.current;
    if (!anchor) return;

    const rect = anchor.getBoundingClientRect();
    const panelHeight = panel?.offsetHeight || DEFAULT_FLYOUT_HEIGHT;
    const panelWidth = panel?.offsetWidth || flyoutWidth;
    const margin = 6;

    let left = rect.right + margin;
    if (left + panelWidth > window.innerWidth - margin) {
      left = Math.max(margin, rect.left - panelWidth - margin);
    }

    let top = rect.top;
    if (top + panelHeight > window.innerHeight - margin) {
      top = Math.max(margin, window.innerHeight - panelHeight - margin);
    }

    setStyle({
      top,
      left,
      maxHeight: Math.max(120, window.innerHeight - top - margin),
    });
  }, [anchorRef, panelRef, flyoutWidth]);

  useLayoutEffect(() => {
    if (!open) return undefined;
    updatePosition();
    window.addEventListener('resize', updatePosition);
    window.addEventListener('scroll', updatePosition, true);
    return () => {
      window.removeEventListener('resize', updatePosition);
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, [open, updatePosition]);

  return { style, updatePosition };
}
